// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {AudioFileMetaDataEntity, getExtensionByType} from '@spout/any-shared/models';

export function fileDeviceStorage(file: Partial<AudioFileMetaDataEntity>): string {
  if (file.type) {
    return `projects/${file.projectId}/${file.id}.${getExtensionByType(file.type)}`;
  }
  return '';
}
